import { render, staticRenderFns } from "./table-prime.vue?vue&type=template&id=5b542f82"
import script from "./table-prime.vue?vue&type=script&lang=js"
export * from "./table-prime.vue?vue&type=script&lang=js"
import style0 from "./table-prime.vue?vue&type=style&index=0&id=5b542f82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports